import { render, staticRenderFns } from "./information-add.view.vue?vue&type=template&id=5f159f7a&"
import script from "./information-add.view.vue?vue&type=script&lang=ts&"
export * from "./information-add.view.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports